module.exports = __webpack_public_path__ + "assets/ab1d833799265e0f3d1dfbd2622ee4b2.mp3";